import {
  mapGetters
} from "vuex";
export default {
  data() {
    return {
      activity: {
        newCompany: "Създаване на Фирма",
        editCompany: "Редактиране на Фирма",
        newUser: "Създаване на потребител",
        editUser: "Редактиране на потребител",
        editPaidLeave: "Редактиране на платен отпуск",
        newReport: "Създаване на отчет",
        editReport: "Редактиране на отчет",
        newCalendar: "Създаване на график",
        deleteCalendar: "Изтриване на график",
        newOtpusk: "Създаване на отпуск",
        confirmOtpusk: "Потвърждаване на отпуск",
        rejectOtpusk: "Отказване на отпуск",
        deleteOtpusk: "Изтриване на отпуск",
        editRates: "Редактиране на ставки",
        editSalary: "Запазване на форма заплата"
      }
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser"
      // ...
    ])
  },
  methods: {
    newLog(activity, additional) {
      const info = additional || '';
      if (this.activity[activity]) {
        let url = `${process.env.VUE_APP_BASE_URI}/log`;
        let log = {
          activity: `${this.activity[activity]} - ${info}`,
          createdBy: this.getUser._id
        }
        this.$http
          .post(url, log)
          .then(a => {
            if (a.data.errors) {
              console.log(a.data.errors)
            }
          })
          .catch(error => {
            console.log(error.response);
          });
      }
    }
  }
}